<div class="bp-modal mod-lg">
	<bp-modal-header [title]="'404_not_found_title' | translate">
		<a right (click)="close()" (keydown.enter)="close()" [tabIndex]="0">{{ "close" | translate }}</a>
	</bp-modal-header>
	<div class="bp-modal-body">
		<div class="bp-modal-body-section pt-10">
			<div class="justify-center mb-20">
				<!-- OFFLINE 404 panda SVG usage: -->
				<svg
					height="164"
					viewBox="0 0 242 164"
					width="242"
					xmlns="http://www.w3.org/2000/svg"
					xmlns:xlink="http://www.w3.org/1999/xlink">
					<defs>
						<radialGradient
							id="a"
							cx="50%"
							cy="50%"
							gradientTransform="matrix(0 1 -1.06567614 0 1.032838 0)"
							r="39.564502%">
							<stop offset="0" />
							<stop offset="1" stop-opacity="0" />
						</radialGradient>
						<linearGradient id="b">
							<stop offset="0" stop-color="#b3b3b3" />
							<stop offset="1" stop-color="#7c7c7c" />
						</linearGradient>
						<linearGradient id="c" x1="56.55107%" x2="43.44893%" xlink:href="#b" y1="6.260893%" y2="100%" />
						<linearGradient id="d" x1="50%" x2="50%" y1="0%" y2="100%">
							<stop offset="0" stop-color="#8d8d8d" />
							<stop offset="1" stop-color="#555454" />
						</linearGradient>
						<linearGradient id="e" x1="71.044644%" x2="362.887851%" xlink:href="#b" y1="50%" y2="50%" />
						<filter id="f" height="900%" width="121.1%" x="-10.5%" y="-400%">
							<feGaussianBlur in="SourceGraphic" stdDeviation="4" />
						</filter>
						<linearGradient id="g" x1="32.479026%" x2="24.497638%" y1="39.585326%" y2="73.184806%">
							<stop offset="0" stop-color="#363636" />
							<stop offset="1" stop-color="#0f0f0f" />
						</linearGradient>
						<linearGradient id="h" x1="94.280771%" x2="77.220366%" y1="50.924382%" y2="51.034856%">
							<stop offset="0" stop-color="#547657" />
							<stop offset="1" stop-color="#394d46" />
						</linearGradient>
						<linearGradient id="i" x1="100%" x2="0%" y1="50%" y2="50%">
							<stop offset="0" stop-color="#2ceb8f" />
							<stop offset=".560637667" stop-color="#27d17f" />
							<stop offset="1" stop-color="#25c678" />
							<stop offset="1" stop-color="#23bd73" />
						</linearGradient>
						<linearGradient id="j" x1="96.702363%" x2="-91.885387%" y1="50.0005%" y2="50%">
							<stop offset="0" stop-color="#7ff5bc" />
							<stop offset=".603765916" stop-color="#27d17f" />
							<stop offset="1" stop-color="#23bd73" />
						</linearGradient>
						<linearGradient id="k" x1="32.479026%" x2="24.497638%" y1="37.008057%" y2="78.922239%">
							<stop offset="0" stop-color="#3b3b3b" />
							<stop offset="1" stop-color="#0f0f0f" />
						</linearGradient>
						<path
							id="l"
							d="m164.90918 95.7246094c-4.776367 2.2436523-6.905554 6.7131456-9.899903 8.7275386-8.131347 5.470215-11.089374 1.684032-18.085449-14.5297847-.380674-.8822355-6.157944-3.5186055-3.84082-6.1748047 9.141808-10.47957 7.721335 3.067164 10.064453 5.3217773 1.162165 1.1182674 3.98894 6.7517394 9.949327 1.5230009" />
						<mask id="m" fill="#fff">
							<use fill="#fff" fill-rule="evenodd" xlink:href="#l" />
						</mask>
					</defs>
					<g fill="none" fill-rule="evenodd">
						<ellipse cx="121" cy="82" fill="url(#a)" opacity=".1" rx="121" ry="82" />
						<g transform="translate(71 61)">
							<path
								d="m18.2173913 36.3829787h18.4927536v18.5106383h-18.4927536z"
								fill="#282828"
								transform="matrix(0 -1 1 0 -18.17453 73.102066)" />
							<path
								d="m17.0289855 30h11.942029c1.1045695 0 2 .8954305 2 2v40.0425532c0 1.1045695-.8954305 2-2 2h-11.942029c-1.1045695 0-2-.8954305-2-2v-40.0425532c0-1.1045695.8954305-2 2-2z"
								fill="url(#c)"
								transform="matrix(0 -1 1 0 -29.021277 75.021277)" />
							<path
								d="m19.4927536 21.7021277h10.2028986v31.2765957h-10.2028986z"
								fill="url(#d)"
								transform="matrix(0 -1 1 0 -12.746223 61.934629)" />
							<path
								d="m2.91304348 9.77821835 30.60869562-5.31013324v30.99536489l-29.7004696.9195287z"
								fill="url(#e)" />
							<rect
								fill="#757575"
								height="37.659575"
								rx="3"
								transform="matrix(.99756405 -.06975647 .06975647 .99756405 -1.268601 2.608194)"
								width="10.202899"
								x="31.608696"
								y=".638298" />
						</g>
						<g transform="translate(64 54)">
							<ellipse cx="57" cy="67.5" fill="#545454" filter="url(#f)" rx="57" ry="1.5" />
							<path
								d="m74.2085666 38.1674633c-2.2224195 2.8240934-4.4766672 2.9221949-6.7164333 4.4401921-2.1594539 1.4635658-2.3323196 3.0526688-4.1726951 4.2366095-2.3037853 1.482059-5.7298323 1.326405-6.880148 2.059911-3.8874781 2.4788747-2.9768339 3.7619304-.979875 4.4174708 2.4228381.7953436 4.0070326.2901892 4.4437146 1.1428803 1.0158532 1.9836147-2.3098358 1.9458502-7.5318746-.4989593-1.3480097-.6310996-3.315473 1.1237994-4.0306559 1.8008885-2.6826758 2.5397844-3.1577326 4.7487229-.9121368 7.2158234 1.6299196 1.7906942 4.0180528 4.1738661 6.8005271 4.5610693 26.4512077 3.6808934 58.1555664 12.7312506 56.0256294-17.5108343-.491308-6.9758867.386649-6.211543-.736277-13.9463203 1.227217-7.1728428-.119012-10.6437452-4.038687-10.4127072-2.926452.1724942-10.8068836-4.541162-20.9493976 0-1.6376277.7332238-2.9787411.9496997-5.7494528 4.8241817-.7602767 1.0631487-2.2843561 3.6197468-4.572238 7.6697945z"
								fill="url(#g)" />
							<path
								d="m110.356436 32.0233702c-.61819-5.4682227.15722-11.1820891-3.248925-15.7671179-2.890237-3.8905641-9.5314679-13.63464872-16.1768469-15.15078355-12.5241406-2.85736686-16.495375 11.31449795-19.724496 19.48917485-1.788006 4.5264242-9.7618841 9.5896381-1.7446741 13.896838 13.5441214 7.276501 5.6905032-7.5689943 15.7317772-7.4285581 16.8970808.2363207 12.4243119-.4840883 24.9510798 7.039145"
								fill="#fff" />
							<path
								d="m77.2767653 18.1525222c-1.7287466-1.0563048-3.6138989 1.8926744-3.603498 3.6529022.0082709 1.3866741 1.2502214 2.9329397 1.8747514 3.9743468.9966613 1.661938 1.9372834 1.6383397 2.4768272-1.2528351.2194244-1.1757981.1890025-1.0978061 0-3.6034351z"
								fill="#282828" />
							<path
								d="m66.608949 30.0964912c3.9304797-1.2338203 3.397588.5275551 2.5835559 1.0382744-.7109405.4460402-2.3082231.3685109-2.5984455-.6384112z"
								fill="#282828" />
							<path
								d="m87.4110967 46.0130122c-12.7302403 3.6388827-4.3719751 3.2082686-9.2517385 12.3075841-1.1666018 2.1753674-9.5730037 4.1747251-7.3231816 8.746365 2.7701362 5.6289186 13.5795727 6.0540279 26.6583991 4.0429405 7.6499553-1.176308 10.2517433-4.3826471 11.8055963-7.7164156 2.439403-5.2337018 1.938562-18.5242074 0-20.3059699-3.798796-3.4915324-11.5821911-.0206813-21.8890753 2.9254959z"
								fill="#fff" />
							<path
								d="m94.510122 11.0644801c-.5972074-1.762411-.8703675-3.20413367-2.9855982-4.18190586-3.050054-1.40989732-5.9176234.09816898-4.6885177 7.13299496.2345174 1.3422682 2.7430738-.7836609 3.8028064-.0500106.7631191.5283056-.4437218 2.2802207.2753302 2.8732949 4.8043354 3.9626166 4.1931868-4.0119624 3.5959793-5.7743734z"
								fill="#353535" />
							<g stroke-linecap="round" stroke-linejoin="round">
								<path
									d="m62.7326733 54.4298246c6.3554369-3.2005706 12.370936-4.1915349 19.3069307-4.4824562"
									stroke="#fff" />
								<path
									d="m52.4356436 55.7105263c-.8306649 1.6340425-2.7834561 3.5219298-2.5559543 7.0438597"
									stroke="#fff" />
								<path
									d="m71.0990099 34.5789474c1.9400251 0 3.2364171-.6222171 4.5049505-1.2807018"
									stroke="#282828" />
							</g>
						</g>
						<g transform="matrix(.99862953 -.05233596 .05233596 .99862953 126.994635 32.292849)">
							<path
								d="m0 49.5474577c.03698849-1.4542644 8.08240912-2.1813965 24.1362619-2.1813965 16.0538527 0 24.0476574.7271321 23.9814139 2.1813965l.2984312 6.447656c.0238805.5149922-.3476908.9637115-.8580987 1.0363136-5.1116677.7271-12.9733731 1.09065-23.5851161 1.09065-10.6141501 0-18.15893568-.3637149-22.63435675-1.0911449-.45574909-.0740577-.80152986-.4505243-.83668301-.9109111z"
								fill="url(#h)" />
							<path
								d="m5.69015667 2.71098564c0-2.1296928 9.01482393-2.71098564 18.84665913-2.71098564s19.2610022.58129284 19.2610022 2.71098564c.8995508 14.12267676 2.1288302 31.67596616 3.6878382 52.65986846-10.6228145 1.9780243-18.4082506 2.9670365-23.3563086 2.9670365-4.9480579 0-12.7334941-.9890122-23.35630852-2.9670365 2.03759463-17.6448548 3.67663382-35.1981443 4.91711759-52.65986846z"
								fill="url(#i)" />
							<path
								d="m0 49.5474577c3.09238951 1.4496676 11.0356025 2.1745015 23.829639 2.1745015s20.8900488-.7248339 24.2880368-2.1745015l.4141667 6.5124144c.0310854.4882635-.295692.927309-.7723254 1.0377091-5.141099 1.1908067-13.0451683 1.78621-23.7122081 1.78621-10.6777638 0-18.43989659-.5966011-23.2863983-1.7898033-.44683933-.1100413-.7609107-.5108151-.7609107-.9710048z"
								fill="url(#j)" />
						</g>
						<use fill="url(#k)" xlink:href="#l" />
						<ellipse cx="136" cy="88.5" mask="url(#m)" rx="10" ry="11.5" />
					</g>
				</svg>
				<!-- end OFFLINE 404 panda SVG usage -->
			</div>
			<h2 class="font-size-24 font-bold text-center">
				{{ "404_modal_something_went_wrong_header" | translate }}
			</h2>
			<p class="text-center text-light">{{ "404_modal_something_went_wrong_detail_text" | translate }}</p>
			<p class="mb-30 text-center">
				<a href="{{ link }}" target="_blank">{{ "visit_our_help_center" | translate }}</a>
			</p>
		</div>
	</div>
</div>
